import displayName from 'component-lib/displayName';
import LabelBase from './LabelBase';

export default class LinkLabel extends LabelBase {
    static displayName = displayName('Widgets/Labels/LinkLabel');

    /* eslint-disable class-methods-use-this */
    getLabelStyle() { return 'link-label'; }
}
